import { Tabs } from "antd";
import React, { useEffect, useState } from "react";
import FeeConfigurationTab from "./FeeConfigurationTab";
import LimitsBalanceTab from "./LimitsBalanceTab";
import SecurityTab from "./SecurityTab";
import SettingTab from "./SettingTab";
import { getSettingDetails } from "../../api/SettingApi";

const { TabPane } = Tabs;

export default function SettingMain() {
  const [settingDetails, setSettingDetails] = useState({});

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await getSettingDetails();

      if (response?.data.data) {
        // Populate form with backend data
        setSettingDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };
  console.log("settingDetails", settingDetails);

  return (
    <div style={{ padding: 10 }}>
      <h1 className="um-title">System Settings</h1>
      <span className="um-description">
        Configure comprehensive limits, fees, and security settings
      </span>
      <Tabs defaultActiveKey="1" type="card" style={{ marginTop: 24 }}>
        <TabPane tab="Limits & Balance" key="1">
          <LimitsBalanceTab
            limitData={settingDetails.limits}
            fetchSettings={fetchSettings}
          />
        </TabPane>
        <TabPane tab="Fee Configuration" key="2">
          <FeeConfigurationTab
            feesData={settingDetails.feeConfig}
            fetchSettings={fetchSettings}
          />
        </TabPane>
        <TabPane tab="Security" key="3">
          <SecurityTab
            adminSetting={settingDetails.adminSetting}
            fetchSettings={fetchSettings}
          />
        </TabPane>
        <TabPane tab="Setting" key="4">
          <SettingTab
            adminSetting={settingDetails.adminSetting}
            fetchSettings={fetchSettings}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}
